import { render, staticRenderFns } from "./investigationAdd.vue?vue&type=template&id=5aec0660&scoped=true&"
import script from "./investigationAdd.vue?vue&type=script&lang=js&"
export * from "./investigationAdd.vue?vue&type=script&lang=js&"
import style0 from "./investigationAdd.vue?vue&type=style&index=0&id=5aec0660&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aec0660",
  null
  
)

export default component.exports